var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 17.623,
    viewBox: "0 0 21 17.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Car",
    transform: "translate(-190.151 -145.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M209.728,153.18l-1.534-6.117a1.563,1.563,0,0,0-1.529-1.216H194.638a1.563,1.563,0,0,0-1.528,1.211l-1.536,6.122a1.782,1.782,0,0,0-1.423,1.743v4.888a.933.933,0,0,0,.932.932h1.2v1.471a1.258,1.258,0,0,0,1.256,1.256H195.8a1.258,1.258,0,0,0,1.256-1.256v-1.471h7.194v1.471a1.258,1.258,0,0,0,1.256,1.256h2.256a1.258,1.258,0,0,0,1.256-1.256v-1.471h1.2a.933.933,0,0,0,.932-.932v-4.888a1.782,1.782,0,0,0-1.423-1.743Zm-15.6-5.871,0-.009a.517.517,0,0,1,.506-.4h12.026a.52.52,0,0,1,.508.411l1.464,5.835H192.666Zm1.874,14.9a.205.205,0,0,1-.206.205h-2.256a.205.205,0,0,1-.206-.205v-1.471H196Zm11.963,0a.205.205,0,0,1-.206.205H205.5a.205.205,0,0,1-.206-.205v-1.471h2.667Zm2.134-2.522H191.2v-4.769a.729.729,0,0,1,.728-.728h17.441a.729.729,0,0,1,.728.728Z",
    transform: "translate(0)",
    fill: "#0077b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M412.7,286.21a1.877,1.877,0,1,0,1.877,1.877A1.879,1.879,0,0,0,412.7,286.21Zm0,2.7a.826.826,0,1,1,.826-.826A.827.827,0,0,1,412.7,288.912Z",
    transform: "translate(-206.174 -131.143)",
    fill: "#f28d18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M233.917,286.21a1.877,1.877,0,1,0,1.877,1.877A1.879,1.879,0,0,0,233.917,286.21Zm0,2.7a.826.826,0,1,1,.826-.826A.827.827,0,0,1,233.917,288.912Z",
    transform: "translate(-39.138 -131.143)",
    fill: "#f28d18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M310.473,306.78h-4.847a.525.525,0,0,0,0,1.051h4.847a.525.525,0,0,0,0-1.051Z",
    transform: "translate(-107.4 -150.362)",
    fill: "#f28d18"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.19d2a73f8934e99bcc7554b5a9e17ffd.svg";
export { ForwardRef as ReactComponent };